// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_lw3","cls2":"SimplePaperPodcast-cls2_JzF SimplePaperPodcast-cls1_lw3"};